import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SET_FACILITIES, SetFacilitiesType } from "../actions/facilities";

export interface FacilitiesState {
  facilities: racehorse360.IFacility[];
}

export const initialState: FacilitiesState = {
  facilities: []
};

export default (
  state = initialState,
  action: SetFacilitiesType
): FacilitiesState => {
  switch (action.type) {
    case SET_FACILITIES:
      return {
        ...state,
        facilities: action.facilities
      };

    default:
      return state;
  }
};
